import * as React from 'react';

import LabelEditorCtrl from '@webapp/controllers/label/label-editor';

interface LabelGeneralPageProps {
  className?: string;
}

export const LabelGeneralPage: React.FC<LabelGeneralPageProps> = (props) => {
  return <LabelEditorCtrl className={props.className} />;
};

export default LabelGeneralPage;
